/**
 * Input. Implements DESIGN.md §Components > Inputs / Fields, "Text input (light)":
 * 48px, 10px radius, surface fill, 1px border, 16px text, 0 16px padding, placeholder
 * in text-placeholder, 2px focus-ring outline offset 1px, danger border when invalid.
 * Reference: stars.css §5 Forms. The dark input (52px, 16px radius) has no 52px
 * height token and is not built here.
 */
import React, { forwardRef } from 'react';
import { cn } from './cn';

export const Input = forwardRef(function Input({ type = 'text', invalid = false, className, ...props }, ref) {
  return (
    <input
      ref={ref}
      type={type}
      aria-invalid={invalid ? 'true' : props['aria-invalid']}
      className={cn(
        'tw-block tw-w-full tw-min-h-12 tw-px-4 tw-rounded-md tw-border tw-border-solid tw-bg-surface tw-text-text tw-text-md',
        'tw-border-border placeholder:tw-text-text-placeholder',
        'tw-transition-colors tw-duration-fast tw-ease-out',
        'focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-1 focus-visible:tw-outline-focus-ring',
        'disabled:tw-opacity-45 disabled:tw-cursor-not-allowed',
        invalid && 'tw-border-danger',
        className,
      )}
      {...props}
    />
  );
});
